// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".04cc0d2c3d870f8a94c3d1541843226d.js";
};